import React from 'react';
import styled from 'styled-components';
import { Box } from '@cko/primitives';
import { debounce } from '@cko/utils';
import useResizeObserver from '../../../hooks/useResizeObserver/useResizeObserver';
import { useLayout } from '../../../context/Layout';
const Container = styled(Box) `
  height: 100%;

  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: ${({ isFullPage }) => (isFullPage ? 'auto' : '284px auto')};
    grid-auto-flow: row;
    min-width: 0;
  }
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const Layout = ({ leftElement, children }) => {
    const { isFullPage, setBodyWidth } = useLayout();
    const onResize = debounce(({ width }) => {
        if (width) {
            setBodyWidth(width + 80);
        }
    }, 100);
    const { ref } = useResizeObserver({ onResize });
    return (React.createElement(Container, { isFullPage: isFullPage },
        !isFullPage && leftElement,
        React.createElement(Box, { ref: ref, p: isFullPage ? 'var(--layout-sandgrain)' : 'var(--layout-saxophone)', minWidth: 0, "data-testid": "app-body" }, children)));
};
